// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8f6404cf","276":"e73b9208","726":"63e59fed"}[chunkId] + ".chunk.js";
};